import React, {useState, useEffect} from 'react';
import {FiChevronRight, FiHome} from "react-icons/fi";
import {Link} from "react-router-dom";
import {useTranslation} from "react-i18next";
import cx from "classnames";
import moment from "moment";
import {addPublisher, getAllPublishers} from "../services/campaignServices";
import Modal from "./Modal";
import {useForm} from "react-hook-form";

function AddPublisherModal({close}){

  const {t} = useTranslation();
  const { register, handleSubmit, watch, setValue, formState: { errors } } = useForm();

  const [isActive, setIsActive] = useState(true);

  const onSubmit = async (data)=>{

    const submitData = {
      name: data.name,
      email: data.email,
      status: isActive ? 1 : 0
    }

    try {
      const res = await addPublisher(submitData);

      if(res){
        close();
      }
    } catch (e){
      console.log(e);
    }
  }

  return(
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="mb-4">
        <div className='px-2.5 mb-0.5 flex items-center justify-between'>
          <label className='text-xs text-gray-500 font-semibold'>
            {t("PUBLISHERS.TABLE.NAME")} *
          </label>
        </div>
        <input
          className='border rounded-lg px-2 py-1.5 text-sm w-full'
          placeholder={t("PUBLISHERS.TABLE.NAME")}
          {...register("name", {required: true})}
        />
      </div>
      <div className="mb-4">
        <div className='px-2.5 mb-0.5 flex items-center justify-between'>
          <label className='text-xs text-gray-500 font-semibold'>
            {t("PUBLISHERS.TABLE.EMAIL")} *
          </label>
        </div>
        <input
          className='border rounded-lg px-2 py-1.5 text-sm w-full'
          placeholder={t("PUBLISHERS.TABLE.EMAIL")}
          {...register("email", {required: true})}
        />
      </div>
      <div className="flex items-center justify-between mt-7">
        <div className="h-8 flex items-center">
          <label className="inline-flex items-center cursor-pointer">
            <input type="checkbox" value="" className="sr-only peer" checked={isActive}
                   onChange={(e) => setIsActive(e.target.checked)}/>
            <div
              className="relative z-0 w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
            <span className="ms-3 text-sm font-medium text-gray-900">{t("CAMPAIGNS.TABLE.IS_ACTIVE")}</span>
          </label>
        </div>
        <input
          type="submit"
          value={t("GLOBAL.SAVE")}
          className='border border-azure font-semibold cursor-pointer rounded-lg px-4 py-1.5 text-sm text-azure hover:text-white hover:bg-azure'
        />
      </div>
    </form>
  )
}

function Publisher() {

  const {t} = useTranslation();

  const [publishers, setPublishers] = useState([]);
  const [isAddPublisherModalOpen, setIsAddPublisherModalOpen] = useState(false);

  const openAddPublisherModal = () => {
    document.getElementsByTagName('body')[0].style.overflowY = "hidden";
    setIsAddPublisherModalOpen(true);
  }

  const closeAddPublisherModal = () => {
    document.getElementsByTagName('body')[0].style.overflowY = "auto";
    setIsAddPublisherModalOpen(false);
    fetchPublishers();
  }

  const fetchPublishers = async () => {
    await getAllPublishers()
      .then((res) => setPublishers(res.results))
      .catch((err) => {
        console.log(err)
      });
  }

  useEffect(() => {
    fetchPublishers();
  }, []);

  return (
    <div>
      <div className="text-gray-500 flex items-center gap-2 mt-2 mb-6">
        <span className="text-xs font-semibold flex items-center">
          <FiHome size={12}/> <FiChevronRight size={12}/>
        </span>
        <h4 className="text-xs font-semibold text-gray-500">{t("PUBLISHERS.TITLE")}</h4>
      </div>
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-xl font-bold">{t("PUBLISHERS.TITLE")}</h1>
        <button onClick={() => openAddPublisherModal()}
                className="cursor-pointer bg-azure px-4 py-2 text-sm font-semibold rounded-lg text-white hover:opacity-60 hover:shadow">
          {t("PUBLISHERS.ADD_BTN")}
        </button>
      </div>
      <div className='bg-white p-3 rounded-lg mt-4 shadow overflow-x-auto'>
        <table className="min-w-full border-collapse" id='my-applications-table'>
          <thead className="bg-gray-100 customShadow">
          <tr>
            <th className="text-left py-3 px-2 uppercase font-semibold text-xs">
              {t("PUBLISHERS.TABLE.NAME")}
            </th>
            <th className="text-left py-3 px-2 uppercase font-semibold text-xs">
              {t("PUBLISHERS.TABLE.EMAIL")}
            </th>
            <th className="text-left py-3 px-2 uppercase font-semibold text-xs">
              {t("PUBLISHERS.TABLE.PUB_TOKEN")}
            </th>
            <th className="text-left py-3 px-2 uppercase font-semibold text-xs">
              {t("PUBLISHERS.TABLE.STATUS")}
            </th>
            <th className="text-left py-3 px-2 uppercase font-semibold text-xs">
              {t("PUBLISHERS.TABLE.DATE_IN")}
            </th>
          </tr>
          </thead>
          <tbody className="text-gray-800 text-sm ">
          {
            publishers.map((it) =>
              <tr key={it.publisherId} className={cx('border')}>
                <td className="text-left py-3 px-2">{it.publisherName}</td>
                <td className="text-left py-3 px-2">{it.email}</td>
                <td className="text-left py-3 px-2">{it.pubToken}</td>
                <td className="text-left py-3 px-2">{it.status === 1 ? "True" : "False"}</td>
                <td className="text-left py-3 px-2">{moment(it.dateIn).calendar()}</td>
              </tr>
            )
          }
          </tbody>
        </table>
      </div>

      <Modal isOpen={isAddPublisherModalOpen} close={closeAddPublisherModal} title={t("PUBLISHERS.ADD_BTN")} >
        <AddPublisherModal close={closeAddPublisherModal} />
      </Modal>
    </div>
  );
}

export default Publisher;
